import { StatsScenario, ScenarioStatistics } from '@customer/store/apis/scenariosApi';
import { ComponentType } from 'react';
import { FilterGroup } from '@customer/filters/types';
import { LineChartScenarioProps } from './line-chart-scenario/LineChartScenario';
import { BarChartScenarioProps } from './bar-chart-scenario/BarChartScenario';
import { TimeRange } from '@customer/store/slices/globalSlice';
import { AreaChartScenarioProps } from './area-chart-scenario/AreaChartScenario';

export enum ChartColorScheme {
  RedOrangeYellow,
  RedYellowGrey,
  RedOrangeGrey,
  RedGrey,
  OrangeGrey,
  YellowGrey,
  Blue,
  Custom,
}

export type CustomColorSchemeFunc = (data: ScenarioStatistics | undefined) => ThemeColorPair[];

export interface BarChartByProps {
  scenario: StatsScenario;
  filterGroup?: FilterGroup;
  colorScheme: ChartColorScheme;
  customColorSchemeFunc?: CustomColorSchemeFunc;
  includeTimeRange?: boolean;
  timeRange?: TimeRange;
  histogram?: boolean;
  tooltipTransKey: string;
  includeAssetId?: boolean;
  assetId?: string;
}

export type LineChartByProps = BarChartByProps;

export type HistogramChartByProps = Omit<BarChartByProps, 'histogram'>;

export interface ScenarioConfig {
  title: string;
  ChartComponent:
    | ComponentType<BarChartScenarioProps>
    | ComponentType<LineChartScenarioProps>
    | ComponentType<AreaChartScenarioProps>
    | ComponentType<HistogramChartByProps>;
  scenario: StatsScenario;
  hideResultsLimited?: boolean;
  enableCustomTimeRange?: boolean;
}

export type ThemeColorPair = [string, string];

// Color pairs for light/dark theme
const red: ThemeColorPair = ['#F34336', '#F34336']; // --static-red-500
const orange: ThemeColorPair = ['#FF8B3A', '#FF8B3A']; // --static-orange-500
const yellow: ThemeColorPair = ['#FEC600', '#FEC600']; // --static-yellow-500
const brandBlue: ThemeColorPair = ['#3397C7', '#3397C7']; // --static-brand-400
const backgroundGeneralLowest: ThemeColorPair = ['#EEEEEE', '#FFFFFF29']; // --color-background-general-lowest-hover

export const schemeRedOrangeYellow: ThemeColorPair[] = [red, orange, yellow];

export const schemeRedYellowGrey: ThemeColorPair[] = [red, yellow, backgroundGeneralLowest];

export const schemeRedOrangeGrey: ThemeColorPair[] = [red, orange, backgroundGeneralLowest];

export const schemeRedGrey: ThemeColorPair[] = [red, backgroundGeneralLowest];

export const schemeOrangeGrey: ThemeColorPair[] = [orange, backgroundGeneralLowest];

export const schemeYellowGrey: ThemeColorPair[] = [yellow, backgroundGeneralLowest];

export const schemeBlue: ThemeColorPair[] = [brandBlue];

export const schemeGrey: ThemeColorPair[] = [backgroundGeneralLowest];
